import { ProjectStepCommentItem, ProjectStepGridRow, ProjectStepItem } from './types';

export const removeCommentFromProjectStepTree = (
  rows: ProjectStepItem[],
  projectStepId: number,
  commentId: number
): ProjectStepItem[] => {
  return rows.map((item) => {
    if (item.id === projectStepId) {
      return {
        ...item,
        comments: item.comments.filter((comment) => comment.id !== commentId),
      };
    }

    return {
      ...item,
      subTasks: (item.subTasks ?? []).map((subTask) =>
        subTask.id === projectStepId
          ? {
              ...subTask,
              comments: subTask.comments.filter((comment) => comment.id !== commentId),
            }
          : subTask
      ),
    };
  });
};

export const flattenProjectSteps = (rows: ProjectStepItem[]): ProjectStepGridRow[] => {
  return rows.flatMap((parent, parentIndex) => {
    const parentRowId = `task-${parent.id}-${parentIndex}`;

    const parentPath = '\u200B'.repeat(parentIndex + 1); // görünmez ama benzersiz

    const parentRow: ProjectStepGridRow = {
      ...parent,
      rowId: parentRowId,
      treePath: [parentPath],
      isSubTask: false,
      parentRowId: null,
    };

    const childRows: ProjectStepGridRow[] = (parent.subTasks ?? []).map((subTask, childIndex) => {
      const childRowId = `task-${parent.id}-${parentIndex}-sub-${subTask.id}-${childIndex}`;
      const childPath = '\u200C'.repeat(childIndex + 1); // görünmez ama benzersiz

      return {
        ...subTask,
        rowId: childRowId,
        treePath: [parentPath, childPath],
        isSubTask: true,
        parentRowId: parent.id,
      };
    });

    return [parentRow, ...childRows];
  });
};

export const appendCommentToProjectStepTree = (
  rows: ProjectStepItem[],
  projectStepId: number,
  newComment: ProjectStepCommentItem
): ProjectStepItem[] => {
  return rows.map((item) => {
    if (item.id === projectStepId) {
      return {
        ...item,
        comments: [...item.comments, newComment],
      };
    }

    return {
      ...item,
      subTasks: (item.subTasks ?? []).map((subTask) =>
        subTask.id === projectStepId
          ? {
              ...subTask,
              comments: [...subTask.comments, newComment],
            }
          : subTask
      ),
    };
  });
};

const getTime = (date?: string) => (date ? new Date(date).getTime() : Infinity);

export const sortByDueDate = (a: any, b: any) => getTime(a.dueDate) - getTime(b.dueDate);
